
import { Message } from "@/services/messages/types";
import { toast } from "sonner";

/**
 * Handles a new message received via realtime
 */
export function handleNewMessage(
  payload: { new: any },
  otherUserId: string,
  reagentId?: string,
  onNewMessage?: () => void,
  refreshMessages?: () => void,
  isMounted: boolean = true
): void {
  if (!isMounted) return;
  
  const newMessage = payload.new as Message;
  
  // Check if this message is part of our conversation
  const isOurConversation = 
    (newMessage.sender_id === otherUserId || newMessage.recipient_id === otherUserId) && 
    (
      (reagentId && newMessage.reagent_id === reagentId) || 
      (!reagentId && !newMessage.reagent_id)
    );

  if (isOurConversation) {
    // Show notification for new message from other user
    if (newMessage.sender_id === otherUserId) {
      toast.info('New message received');
    }
    
    // Refresh messages to show the new one
    if (refreshMessages) {
      refreshMessages();
    }
    
    // Call callback if provided
    if (onNewMessage) {
      onNewMessage();
    }
  }
}
